window.screenedOut = false;
window.reachedScreenout = false;
window.screenOutSent = false;
window.screenOutPassed = false;

function screenout() {
    if(window.hasScreenout && !window.inPreviewMode) {
        window.screenedOut = true;
        window.logExperimentEvent(window.consortEvents.FAILED_SCREENOUT)
    }
}

function showScreenout() {
    let screenoutTextContent = window.screenout_text;
    if (window.screenout_link_url) {
        let redirectText = trans('auto_redirect') + '<br>';
        if(!window.screenout_auto_redirect) {
            redirectText = '';
        }

        const url = addCurrentQueryParamsToUrl(replaceQueryParamsPlaceholders(replaceVariables(window.screenout_link_url)));
        let screenout_link_url_text = window.screenout_link_url_text || url;
        screenoutTextContent += '<br><br>' + redirectText + '<a target="_blank" href="' + url + '"><b><font color="blue">' + screenout_link_url_text + '</font></b></a>';
        if (window.screenout_auto_redirect) {
            handleCustomLinkRedirect(url);
        }
    }

    window.hideAll();
    displayText('content', screenoutTextContent);
    if (window.mindId) {
        $.ajax({
            type: "POST",
            url: "screenout" + window.location.search, //relative to current route user_id/project_id/
            data: ""
        });
    }
}